module.exports = __webpack_public_path__ + "static/img/item-2-2-big.4a494eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-2-2-big.png
// module id = T6vx
// module chunks = 2